import { useFlag } from '@rsos/flags';

export const useTranscriptFeedbackApi = (): boolean => {
  return useFlag('transcript_feedback_api');
};
